export const validate = (validations, value) => {
  const errors = [];
  if (Array.isArray(validations)) {
    validations.forEach(val => {
      if (!val.validate(value)) {
        errors.push(val.message);
      }
    });
  } else {
    if (!validations.validate(value)) {
      errors.push(validations.message);
    }
  }

  return errors;
};

export const getMostRecentValue = (data, propName) => {
  if (data.size === 0) return null;
  return data.get(data.size - 1).get(propName);
};



// WEBPACK FOOTER //
// ./src/subscription/profile/components/profile-utils.js